import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import type { StackScreenProps } from "@react-navigation/stack";
import { InfertilityDiagnosisScreen } from "./InfertilityDiagnosisScreen/InfertilityDiagnosisScreen";
import { InfertilityCauseScreen } from "./InfertilityCauseScreen/InfertilityCauseScreen";
import { InfertilityCauseOtherScreen } from "./InfertilityCauseOtherScreen/InfertilityCauseOtherScreen";
import { PartnerInfertilityDiagnosisScreen } from "./PartnerInfertilityDiagnosisScreen/PartnerInfertilityDiagnosisScreen";
import { InfertilityCompleteScreen } from "./InfertilityCompleteScreen/InfertilityCompleteScreen";
import { InfertilityProvider } from "./InfertilityContext";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";

export type InfertilityStackParamList = {
  InfertilityDiagnosis: undefined;
  InfertilityCause: undefined;
  InfertilityCauseOther: undefined;
  PartnerInfertilityDiagnosis: undefined;
  InfertilityComplete: undefined;
};

export type InfertilityStackScreenProps<
  T extends keyof InfertilityStackParamList,
> = StackScreenProps<InfertilityStackParamList, T>;

const Stack = createNativeStackNavigator<InfertilityStackParamList>();

export function InfertilityNavigator() {
  return (
    <InfertilityProvider>
      <MedicalHistoryQuestionProvider
        section="infertility"
        sectionLabelKey="med_history.review.section_title.infertility"
        helpTextKey="med_history.question_screen.flow_help.infertility"
      >
        <Stack.Navigator
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: "transparent" },
          }}
        >
          <Stack.Screen
            name="InfertilityDiagnosis"
            component={InfertilityDiagnosisScreen}
          />
          <Stack.Screen
            name="InfertilityCause"
            component={InfertilityCauseScreen}
          />
          <Stack.Screen
            name="InfertilityCauseOther"
            component={InfertilityCauseOtherScreen}
          />
          <Stack.Screen
            name="PartnerInfertilityDiagnosis"
            component={PartnerInfertilityDiagnosisScreen}
          />
          <Stack.Screen
            name="InfertilityComplete"
            component={InfertilityCompleteScreen}
          />
        </Stack.Navigator>
      </MedicalHistoryQuestionProvider>
    </InfertilityProvider>
  );
}
